import React from 'react'

export function SmallSplit() {
  return (
    <div style={{ marginLeft: 20, height: 1, width: '35%', backgroundColor: '#FF795B'  }}/>
  )
}
